// ./src/utils/locationHelpers.ts
import { AddressData } from "@/hooks";

/**
 * Format address data into a short display string (for place auto-fill)
 */
export const formatAddressShort = (address: AddressData): string => {
  const parts: string[] = [];

  if (address.address1) {
    parts.push(address.address1);
  }
  if (address.city) {
    parts.push(address.city);
  }
  if (address.region) {
    parts.push(address.region);
  }

  return parts.join(", ");
};

/**
 * Format address data into a full display string (for location field)
 * Includes: address1, city, region, postal code, country
 */
export const formatAddressFull = (address: AddressData): string => {
  const parts: string[] = [];

  // Street address
  if (address.address1) {
    parts.push(address.address1);
  }

  // City
  if (address.city) {
    parts.push(address.city);
  }

  // Region/State with postal code (e.g., "AB T2P 1J9" or "CA 90210")
  const regionPostal: string[] = [];
  if (address.region) {
    regionPostal.push(address.region);
  }
  if (address.postalCode) {
    regionPostal.push(address.postalCode);
  }
  if (regionPostal.length > 0) {
    parts.push(regionPostal.join(" "));
  }

  // Country
  if (address.country) {
    parts.push(address.country);
  }

  return parts.join(", ");
};